function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.89396 274.817C21.2797 230.679 85.8532 152.479 189.061 192.787L381.409 108.486C360.296 153.381 292.269 233.095 189.061 192.787L1.89396 274.817Z",
  fill: "#FD6FFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.1516 338.152C47.1516 289.985 78.8516 193.652 189.652 193.652L338.152 45.1516C334.818 94.6516 300.452 193.652 189.652 193.652L45.1516 338.152Z",
  fill: "#6FFFB0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M112.949 383.303C96.2264 338.088 88.3408 236.98 190.577 194.268L270.355 7.45058e-06C286.361 46.9592 292.814 151.556 190.577 194.268L112.949 383.303Z",
  fill: "#81FCED"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.fc06ab78.svg";
export { ForwardRef as ReactComponent };